import React from 'react';
import styled from 'styled-components';

export default ({ children, ...props }) => (
  <Menu {...props}>{children}</Menu>
);

const Menu = styled.div`
  display: flex;
  align-items: center;
  font-size: .875rem;
  text-transform: uppercase;
  color: #fff;

  > * {
    text-transform: initial;
  }
`;

// @todo 2018-06-28 Is this the right place for this style?
export const menuItemStyle = {
  display: 'flex',
  alignItems: 'center',
  margin: '0 .75rem',
  padding: '.75rem 0',
  textTransform: 'uppercase',
};
